import React from "react";
import { twMerge } from "tailwind-merge";

import { SupText as Text } from "../../../components/UI/Text";

import SupArrowBackAlt from "../../../icons/ArrowBackAlt";
import SupRightArrowAlt from "../../../icons/RightArrowAlt";

import { useOptions } from "./hooks/useOptions";

export interface CarouselButtonProps {
  className?: string;
  fluid?: boolean;
  defaultOption?: string;
  options: string[];
  onChange?: (option: string, index: number) => void;
}

export function SupCarouselButton({ options, fluid = false, className, defaultOption, onChange }: CarouselButtonProps) {
  const { currentIndex, currentOption, setCurrentOptionByIndex } = useOptions(options, { defaultOption, onChange });

  const handleNext = () => {
    setCurrentOptionByIndex(currentIndex + 1);
  };

  const handlePrev = () => {
    setCurrentOptionByIndex(currentIndex - 1);
  };

  return (
    <div className={twMerge("sup-carousel-button inline-flex h-10", fluid && "w-full", className)}>
      <button
        className="inline-flex w-10 bg-neutral-50 text-neutral-600 hover:bg-neutral-700 hover:text-neutral-50 border-0.5 active:bg-neutral-800 active:text-neutral-700 border-neutral-600 justify-center items-center rounded-bl-lg transition-colors duration-200"
        onClick={handlePrev}
      >
        <SupArrowBackAlt />
      </button>
      <div className="flex flex-1 justify-center items-center border-t-0.5 border-b-0.5 border-neutral-600 px-2">
        <Text as="span" variant="button" className="whitespace-nowrap">
          {currentOption}
        </Text>
      </div>
      <button
        className="inline-flex w-10 bg-neutral-50 text-neutral-600 hover:bg-neutral-700 hover:text-neutral-50 border-0.5 active:bg-neutral-800 active:text-neutral-700 border-neutral-600 justify-center items-center rounded-tr-lg transition-colors duration-200"
        onClick={handleNext}
      >
        <SupRightArrowAlt />
      </button>
    </div>
  );
}
